<div class="intent-panel">
  <!-- Toggle handle — always visible, attached to the top-left of the drawer -->
  <button
    class="intent-panel__handle"
    type="button"
    [attr.aria-label]="open ? 'Close tasking options' : 'Open tasking options'"
    (click)="togglePanel()"
  >
    <span class="intent-panel__handle-chevron" aria-hidden="true">{{ open ? '›' : '‹' }}</span>
    <span class="intent-panel__handle-label" aria-hidden="true">Options</span>
    <span class="intent-panel__handle-badge" *ngIf="stripEnabled" aria-hidden="true">1</span>
  </button>

  <!-- Drawer wrapper — clips the slide animation -->
  <div class="intent-panel__drawer-wrapper" [class.intent-panel__drawer-wrapper--open]="open">
    <div class="intent-panel__drawer">
      <div class="intent-panel__drawer-header">
        <span class="intent-panel__drawer-title">Tasking options</span>
      </div>

      <ul class="intent-panel__list" role="list">
        <!-- 2-point strip recommendation -->
        <li
          class="intent-panel__item"
          [class.intent-panel__item--available]="stripAvailable"
          [class.intent-panel__item--unavailable]="!stripAvailable"
        >
          <button
            class="intent-panel__item-trigger"
            type="button"
            [disabled]="!stripAvailable"
            (click)="toggleStripItem()"
            [attr.aria-expanded]="stripAvailable ? stripItemExpanded : null"
          >
            <span class="intent-panel__item-icon" aria-hidden="true">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <rect x="1" y="4" width="12" height="6" rx="1.2" stroke="currentColor" stroke-width="1.4"/>
                <line x1="4" y1="1.5" x2="4" y2="4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
                <line x1="10" y1="1.5" x2="10" y2="4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
              </svg>
            </span>
            <span class="intent-panel__item-name">2-point strip</span>
            <span class="intent-panel__item-status" *ngIf="stripAvailable && stripEnabled">On</span>
            <span class="intent-panel__item-chevron" aria-hidden="true" *ngIf="stripAvailable">
              {{ stripItemExpanded ? '∧' : '∨' }}
            </span>
          </button>

          <p class="intent-panel__item-hint" *ngIf="!stripAvailable">
            Place 2 points on the map first
          </p>

          <div class="intent-panel__item-body" *ngIf="stripAvailable && stripItemExpanded">
            <mat-slide-toggle
              color="primary"
              [checked]="stripEnabled"
              (change)="onStripToggle($event.checked)"
            >
              Render as strip preview
            </mat-slide-toggle>

            <div class="intent-panel__strip-meta" *ngIf="lengthKm !== null">
              <span>Swath: {{ swathKm }} km</span>
              <span>Length: {{ lengthKm | number: '1.0-2' }} km</span>
              <app-leaflet-task-validity-indicator
                *ngIf="validMin !== null && validMax !== null"
                [validMin]="validMin"
                [validMax]="validMax"
                [isValid]="isLengthValid"
                [color]="lengthColor"
              ></app-leaflet-task-validity-indicator>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
